import { RetryActionJobStatus, RetryActionType } from './enums'

/**
 * Enum labels as a title map — the repo pattern (see `customerStatusTitles`). Retool built this
 * label with `_.startCase`, but `startCase` is used nowhere in this app; one map keeps the label
 * identical in the grid column and the modal title.
 */
export const retryActionTypeTitles: Record<RetryActionType, string> = {
  [RetryActionType.RetryFailedPayment]: 'Retry Failed Payment',
}

export const retryActionJobStatusTitles: Record<RetryActionJobStatus, string> = {
  [RetryActionJobStatus.Scheduled]: 'Scheduled',
  [RetryActionJobStatus.Processing]: 'Processing',
  [RetryActionJobStatus.Completed]: 'Completed',
}

export const retryConfigPageSizeOptions: number[] = [20, 50, 100]

/** The backend `limit` default when the query omits it (`PaginationQueryDto` transform). */
export const RETRY_CONFIG_DEFAULT_LIMIT = 20

/**
 * Shown in the `Scheduled at` column when the value is null. The list left-joins only
 * `scheduled` jobs, so a null means nothing is pending — not that the data is missing.
 */
export const RETRY_CONFIG_NO_SCHEDULE_LABEL = 'Completed'
